module.exports = __webpack_public_path__ + "media/images/yoga-1fd51ba61367ca2aff75b015ef02313d.jpg";